/**
 * Created by alex.shmaltsuev on 2016-05-23.
 */
import C from '../../constants/scoreBoard'

// /**
//  *
//  * @param tabsOrder object with all of tabs data
//  * @returns {{activeRequestId: number, closedRequestId: number, supervisedRequestId: number,
//  *     pendingRequestId: number}} names of each tab
//  */
// export function getTabsNames(tabsOrder) {
//     let activeRequestId = -1;
//     let closedRequestId = -1;
//     let supervisedRequestId = -1;
//     let pendingRequestId = -1;
    // for (let i = 0; i < tabs.length; i++) {
    //     switch (tabs[i].name) {
    //         case C.MY_REQUEST_TAB:
    //             activeRequestId = tabs[i].id;
    //             break;
    //         case C.RECENTLY_CLOSED_TAB:
    //             closedRequestId = tabs[i].id;
    //             break;
    //         case C.SUPERVISED_REQUESTS_TAB:
    //             supervisedRequestId = tabs[i].id;
    //             break;
    //         case C.PENDING_MY_APPROVAL_TAB:
    //             pendingRequestId = tabs[i].id;
    //             break;
    //     }
    // }
//     return {activeRequestId, closedRequestId, supervisedRequestId, pendingRequestId};
// }

/**
 *
 * @param req
 * @returns all of the custom list item data needed
 */
export function getRequestInfoData(req, customFields) {
    let reqInfoData = {};
    const infoArray = req.info;
    infoArray.forEach(function (obj){
        reqInfoData[obj.key] = obj;
    });
    if(customFields)  {
        reqInfoData = customFields.map(function(field){
            return reqInfoData[field];
        });
    }
    return reqInfoData;
}



/**
 *
 * @param req - pending request item
 * @returns boolean hasApprove
 */
export function getPendingHasApprove(req) {
    return !!req.hasApproved;
}

/**
 *
 * @param req - pending request item
 * @returns boolean hasEmptyRequred
 */
export function getPendinghasEmptyRequred(req) {
    return !!req.hasEmptyRequred;
}

/**
 *
 * @param tabName
 * @param state the current state of the scoreBoard comp
 * @param props the current props of the scoreBoard comp
 * @returns Array request array for the <b>tabName</b>
 */
export function getTabArrayByName(tabName, state, props) {
    switch (tabName) {
        case state[C.TABS, C.MY_REQUEST_TAB]:
            return props[C.ACTIVE_REQUESTS_ARRAY];
        case state[C.TABS, C.RECENTLY_CLOSED_TAB]:
            return props[C.CLOSED_REQUESTS_ARRAY];
        case state[C.TABS, C.SUPERVISED_REQUESTS_TAB]:
            return props[C.SUPERVISED_REQUESTS_ARRAY];
        case state[C.TABS, C.PENDING_MY_APPROVAL_TAB]:
            return props[C.PENDING_REQUESTS_ARRAY];
        default:
            return [];
    }
}

/**
 *
 * @param tabName
 * @param props
 * @returns {{listItemsArray:  array based on the tabName, totalListItemsCount: counter of all of
 *     the tickets of the tab}}
 */
export function requestsPerTab(tabName, props) {
    let listItemsArray;
    let totalListItemsCount;
    switch (tabName) {
        case C.MY_REQUEST_TAB:
            if (props.isShowAll) {
                listItemsArray = props[C.ACTIVE_REQUESTS_ARRAY];
            } else {
                listItemsArray = props[C.ACTIVE_REQUESTS_ARRAY_WIDGET];
            }
            totalListItemsCount = props[C.ACTIVE_REQUESTS_COUNT];
            break;
        case C.RECENTLY_CLOSED_TAB:
            if (props.isShowAll) {
                listItemsArray = props[C.CLOSED_REQUESTS_ARRAY];
            } else {
                listItemsArray = props[C.CLOSED_REQUESTS_ARRAY_WIDGET];
            }
            totalListItemsCount = props[C.CLOSED_REQUESTS_COUNT];
            break;
        case C.SUPERVISED_REQUESTS_TAB:
            if (props.isShowAll) {
                listItemsArray = props[C.SUPERVISED_REQUESTS_ARRAY];
            } else {
                listItemsArray = props[C.SUPERVISED_REQUESTS_ARRAY_WIDGET];
            }
            totalListItemsCount = props[C.SUPERVISED_REQUESTS_COUNT];
            break;
        case C.PENDING_MY_APPROVAL_TAB:
            if (props.isShowAll) {
                listItemsArray = props[C.PENDING_REQUESTS_ARRAY];
            } else {
                listItemsArray = props[C.PENDING_REQUESTS_ARRAY_WIDGET];
            }
            totalListItemsCount = props[C.PENDING_REQUESTS_COUNT];
            break;
        default:
            listItemsArray = [];
            totalListItemsCount = 0;
    }
    return {listItemsArray, totalListItemsCount};
}




// WEBPACK FOOTER //
// ./components/Scoreboard/scoreBoardHelper.js